import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography, Stack } from '@mui/joy';

import { formatUptime } from '../../general-utilities/heartbeatUtils';
import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';

interface Props {
  heartbeat:DroneHeartBeat;
}

const InfoRow = ({
  label,
  value,
  color = 'neutral'
}: {
  label: string;
  value?: string | number | null;
  color?: 'neutral' | 'danger' | 'primary';
}) => (
  <Stack direction="row" justifyContent="space-between">
    <Typography level="body-sm" textColor="neutral.600">{label}:</Typography>
    <Typography level="body-sm" textColor={`${color}.500`}>{value ?? 'N/A'}</Typography>
  </Stack>
);

export default function SystemInfoCard({ heartbeat}: Props) {
  const { t } = useTranslation();
  return (
    <Card color="neutral" variant="soft">
      <CardContent>
        <Typography gutterBottom level="title-md">
          {t('heartbeat.system_info.title')}
        </Typography>
        <Stack spacing={1}>
          <InfoRow label={t('heartbeat.system_info.device_uuid')} value={heartbeat.device_uuid} />
          <InfoRow label={t('heartbeat.system_info.source')} value={heartbeat.device_uuid_source} />
          <InfoRow label={t('heartbeat.system_info.uptime')} value={formatUptime(heartbeat.uptime_seconds)} />
          <InfoRow
            color={heartbeat.cpu_temperature && heartbeat.cpu_temperature > 70 ? 'danger' : 'primary'}
            label={t('heartbeat.system_info.cpu_temp')}
            value={
              heartbeat.cpu_temperature != null
                ? `${heartbeat.cpu_temperature.toFixed(1)}°C`
                : 'N/A'
            }
          />
          <InfoRow label={t('heartbeat.system_info.interrupts')} value={heartbeat.interrupts?.toLocaleString()} />
        </Stack>
      </CardContent>
    </Card>
  );
}